import { expValEquals, UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { ff, getFeatureFlagValue } from '@atlassian/jira-feature-flagging';

import { fg } from '@atlassian/jira-feature-gating';

export const getPerformanceTrackingConfiguration = () =>
	getFeatureFlagValue('issue.details.editor.performance-tracking', {});

export const getValidTransactionsTrackingConfiguration = ():
	| { samplingRate: number }
	| undefined => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const value = getFeatureFlagValue<any>('issue.details.editor.valid-transactions-tracking', {});

	// workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
	const enabled = typeof value === 'object' && Object.keys(value).length;
	return enabled ? value : undefined;
};

export const isEditorUFOEnabled = () => ff('issue.details.editor.ufo', false);

export const getEnableFlexibleBlockCardInIssueEditor = () =>
	ff('issue.details.editor.enable-flexible-block-card');

export const JIRA_ISSUE_VIEW_EDITOR_AI = 'issue.details.jira-issue-view-editor-ai_sozy';
export const isJiraIssueViewEditorAIEnabled = () => ff(JIRA_ISSUE_VIEW_EDITOR_AI, false);

export const isMediaInlineEnabled = () => ff('issue.details.media-inline', false);

export const INVITE_PROMPT_ON_LINK_INSERT = 'invite_prompt_on_link_insert';
export const isInviteOnLinkInsertEnrolled = () => {
	const [expConfig] = UNSAFE_noExposureExp('invite_prompt_on_link_insert');
	const cohort = expConfig.get('cohort', 'not-enrolled');
	return cohort !== 'not-enrolled';
};

export const INVITE_PROMPT_ON_LINK_INSERT_V2 = 'invite_prompt_on_link_insert_v2';
export const isInviteOnLinkInsertV2Enrolled = () => {
	const [expConfig] = UNSAFE_noExposureExp('invite_prompt_on_link_insert_v2');
	const cohort = expConfig.get('cohort', 'not-enrolled');
	return cohort !== 'not-enrolled';
};

export const STATSIG_GUARD_THIRD_PARTY_NUDGE = 'statsig-guard-third-party-nudge';
const isThirdPartyNudgeStatsigGuardEnabled = () => ff(STATSIG_GUARD_THIRD_PARTY_NUDGE, false);

export const isThirdPartyNudgeEnrolled = () => {
	const isThirdPartyNudgeExperimentEnrolled = () => {
		if (!fg('statsig-guard-third-party-nudge')) return false;

		const [expConfig] = UNSAFE_noExposureExp('third_party_app_nudge_on_after_jira_comment');
		const cohort = expConfig.get('cohort', 'not-enrolled');

		return ['cohort', 'variation'].includes(cohort);
	};

	return isThirdPartyNudgeStatsigGuardEnabled() && isThirdPartyNudgeExperimentEnrolled();
};

export const NEW_LINK_PICKER = 'platform.linking-platform.link-picker_tgrho';
export const isNewLinkPickerEnabled = () =>
	ff('platform.linking-platform.link-picker_tgrho', false);

export const isDevOpsAppRecommenderEnabled = () =>
	ff('devops_app_recommendation_on_link_paste', false) &&
	expValEquals('devops_app_recommendation_on_link_paste', 'cohort', 'variation');

export const getJiraIssuesDatasourceEnabled = () =>
	ff('platform.linking-platform.datasource-jira_issues', false);
